export const parsePriceGroup = (priceGroup, prices) => {
    if (!priceGroup?.id || !Array.isArray(prices)) return null;

    const priceGroupData = {
        id: priceGroup?.id,
        name: priceGroup?.name,
        description: priceGroup?.description,
        status: priceGroup?.status,
        type: priceGroup?.type,
        experienceId: priceGroup?.experienceId,
        priceGroupTabName: priceGroup?.priceGroupTabName,
        currency: priceGroup?.currency,
    };

    const rangesMap = new Map();
    const unitsMap = new Map();
    const bookingOriginsMap = new Map();

    for (const { id, quantityFrom, quantityTo, price, unitId, bookingOriginId, unitLabel, unitType } of prices) {
        const key = `${quantityFrom}-${quantityTo}`;

        if (!rangesMap.has(key)) {
            rangesMap.set(key, { quantityFrom, quantityTo, prices: [] });
        }

        if (!unitsMap.has(unitId)) {
            unitsMap.set(unitId, { id: unitId, name: unitLabel, unitType });
        }

        if (bookingOriginId && !bookingOriginsMap.has(bookingOriginId)) {
            bookingOriginsMap.set(bookingOriginId, bookingOriginId);
        }

        const priceData = {
            id,
            unitId,
            price,
            bookingOriginId,
        };

        rangesMap.get(key)?.prices?.push(priceData);
    }

    return {
        priceGroupData,
        priceRanges: [...rangesMap.values()].map((range, index) => ({ rowId: index, ...range })),
        units: [...unitsMap.values()],
        bookingOrigins: [...bookingOriginsMap.values()],
    };
};

export const getFormattedPrices = (priceRanges = []) => {
    let prices = [];

    if (!Array.isArray(priceRanges)) return prices;

    for (let i = 0; i < priceRanges.length; i++) {
        const { quantityFrom, quantityTo, prices: rangePrices = [] } = priceRanges[i];

        for (let j = 0; j < rangePrices?.length; j++) {
            const price = rangePrices[j];

            const priceToPush = { quantityFrom, quantityTo: Number.isInteger(quantityTo) ? quantityTo : quantityFrom, ...price };
            prices.push(priceToPush);
        }
    }

    return prices;
};

const hasValidRange = (range) => Number.isFinite(range?.id) || Number.isFinite(range?.quantityFrom);

export const getFormattedRanges = (oldRanges = [], newRanges = []) => {
    const rangesFiltered = [];

    if (!Array.isArray(oldRanges) || !Array.isArray(newRanges)) return rangesFiltered;

    for (const newRange of newRanges) {
        if (!hasValidRange(newRange)) continue;

        const oldRange = oldRanges.find((range) => range?.id === newRange.id);

        if (!hasValidRange(oldRange)) continue;

        const { quantityFrom, quantityTo } = newRange;
        const { quantityFrom: oldQuantityFrom, quantityTo: oldQuantityTo } = oldRange;

        if (quantityFrom !== oldQuantityFrom || quantityTo !== oldQuantityTo) {
            rangesFiltered.push({
                oldRange,
                newRange: { quantityFrom, quantityTo: Number.isInteger(quantityTo) ? quantityTo : quantityFrom },
            });
        }
    }

    return rangesFiltered;
};

export const getFormattedPricesToUpdate = (priceGroupData, priceData) => {
    let data = {};
    if (priceGroupData?.name || priceGroupData?.description || Number.isInteger(priceGroupData?.status)) {
        data = { ...priceGroupData };
    }

    if (priceGroupData?.currency?.label) {
        data.currency = priceGroupData.currency.label;
    }

    if (Number.isInteger(priceGroupData?.type)) {
        data.priceType = priceGroupData.type;
    }

    if (Number.isInteger(priceData?.id) && Number.isFinite(priceData?.price)) {
        data.price = { ...priceData };
    }

    return data;
};
